import CustomButton from "components/Atoms/CustomButton"
import React from "react"
import { Link } from "react-router-dom"

const PageNotFound = () => {
  return (
    <div className="h-screen w-full flex flex-col justify-center items-center bg-gray-100">
      <div className="flex flex-col justify-center items-center max-w-xl m-auto text-center">
        <h1 data-testid="404" className="text-8xl text-gray-700">
          Error <span className="text-red-300"> 404</span>
        </h1>
        <p className="mt-3 text-3xl text-gray-600">Page Not Found</p>
        <p className="mt-3 text-xl text-gray-600">
          The route you are trying to access does not exist or you{" "}
          <span className="font-500">don't have the permission</span> to access
          it, please contact your admin in any case.
        </p>
        <Link className="mt-3" to={"/d"}>
          <CustomButton icon="home" dark text="Home Page" />
        </Link>
      </div>
    </div>
  )
}

export default PageNotFound
